// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-52af191d] .input-display > label:first-child {\r\n  font-size: 14px !important;\r\n  color: #727272 !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
